(() => {
  if (customElements.get('app-section')) {
    return;
  }

  class AppSection extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.checkAqurateElement();

      // Watch for dynamically added content (app blocks may load asynchronously)
      this.observer = new MutationObserver(() => {
        this.checkAqurateElement();
      });

      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    /**
     * Check if component contains element with id containing "aqurate"
     * and verify if it has child <product-slider-aqurate>
     * If not found, hide the closest parent with class shopify-section
     */
    checkAqurateElement() {
      // Find the closest parent with class shopify-section
      const shopifySection = this.closest('.shopify-section');
      if (!shopifySection) return;

      // Find all elements with id attribute
      const allElements = this.querySelectorAll('[id]');

      // Search for element with id containing "aqurate"
      let aqurateElement = null;
      for (const element of allElements) {
        if (element.id && element.id.includes('aqurate')) {
          aqurateElement = element;
          break;
        }
      }

      // If element with "aqurate" in id is found
      if (aqurateElement) {
        // Check if it has child <product-slider-aqurate>
        const productSlider = aqurateElement.querySelector('product-slider-aqurate');

        // If child is not found, hide the shopify-section parent
        if (!productSlider) {
          shopifySection.classList.add('hidden');
        } else {
          // If child is found, ensure the shopify-section parent is visible
          shopifySection.classList.remove('hidden');
        }
      }
    }
  }

  customElements.define('app-section', AppSection);
})();
